import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import React from 'react';
import './directcss/PaymentGatewayCardFields.scss';
import styles from './PaymentGatewayCardFields.styles';

export default function PaymentGatewayCardFields({
    handleCardDetailsChangeCb = () => {},
}){
    return <>
        <div className='card-fields-main-contianer'>
            <div>
                <label>
                    Card Number
                    <CardNumberElement
                        className='card-element'
                        onChange={handleCardDetailsChangeCb}
                        options={{
                            showIcon: true,
                        }}
                    />
                </label>
            </div>
            <div style={styles.expiryAndCvvContainer}>
                <div style={styles.expiryAndCvvField}>
                    <label>
                        Expiry Date
                        <CardExpiryElement
                            className='card-element'
                            onChange={handleCardDetailsChangeCb}
                        />
                    </label>
                </div>
                <div style={styles.expiryAndCvvField}>
                    <label>
                        CVV
                        <CardCvcElement
                            className='card-element'
                            onChange={handleCardDetailsChangeCb}
                        />
                    </label>
                </div>
            </div>
        </div>
    </>
}